exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parse36 .title{display:inline-block;width:18px;height:18px;border-radius:50%;font-size:12px;color:#fff;line-height:18px;text-align:center;margin-right:5px}.parse36 .recommend{background-color:#ead636}.parse36 .actual{background-color:#1fc96d}\n", ""]);

// exports
